import { render } from "./Uploader.vue?vue&type=template&id=6cbb2265&scoped=true"
import script from "./Uploader.vue?vue&type=script&lang=js"
export * from "./Uploader.vue?vue&type=script&lang=js"

import "./Uploader.vue?vue&type=style&index=0&id=6cbb2265&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbb2265"]])

export default __exports__